import {
  ACCOUNTTYPE_401k,
  ACCOUNTTYPE_403B,
  ACCOUNTTYPE_529_PLAN,
  ACCOUNTTYPE_BENEFICIARY,
  ACCOUNTTYPE_BROKERAGE, ACCOUNTTYPE_CASH_ACCOUNT,
  ACCOUNTTYPE_CORPORATE_ACCOUNT,
  ACCOUNTTYPE_COVERDELL_ESA,
  ACCOUNTTYPE_CUSTODIAL_ACCOUNT,
  ACCOUNTTYPE_DEFINED_BENEFIT,
  ACCOUNTTYPE_DEFINED_CONTRIBUTION, ACCOUNTTYPE_ESOP,
  ACCOUNTTYPE_FIXED_ANNUITY,
  ACCOUNTTYPE_INDIVIDUAL,
  ACCOUNTTYPE_INDIVIDUAL_401K,
  ACCOUNTTYPE_JOINT_ACCOUNT,
  ACCOUNTTYPE_OTHER,
  ACCOUNTTYPE_PARTNERSHIP,
  ACCOUNTTYPE_PROFIT_SHARING_PLAN,
  ACCOUNTTYPE_ROLLOVER_IRA,
  ACCOUNTTYPE_ROTH_401K,
  ACCOUNTTYPE_ROTH_IRA,
  ACCOUNTTYPE_SEP_IRA,
  ACCOUNTTYPE_SIMPLE_IRA,
  ACCOUNTTYPE_SOLE_PROPRIETORSHIP,
  ACCOUNTTYPE_TENANTS_BY_ENTIRETY,
  ACCOUNTTYPE_TRADITIONAL_IRA,
  ACCOUNTTYPE_TRUST,
  ACCOUNTTYPE_VARIABLE_ANNUITY,
  ACCOUNTYPE_TENANTS_IN_COMMON,
  TAX_CATEGORY_DEFERRED,
  TAX_CATEGORY_EXEMPT,
  TAX_CATEGORY_TAXABLE,
} from "../Utilities/constants";

export default (t) => {
  let accountTypeList = [
    {
      key: ACCOUNTTYPE_401k,
      name: t("ClientDetails.Profile.Accounts.AccountType.four_oh_one"),
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_403B,
      name: t("ClientDetails.Profile.Accounts.AccountType.four_oh_three"),
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_BENEFICIARY,
      name: t("ClientDetails.Profile.Accounts.AccountType.beneficiary"),
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_INDIVIDUAL_401K,
      name: t("ClientDetails.Profile.Accounts.AccountType.individual_401"),
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_DEFINED_CONTRIBUTION,
      name: t(
        "ClientDetails.Profile.Accounts.AccountType.defined_contribution"
      ),
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_DEFINED_BENEFIT,
      name: t("ClientDetails.Profile.Accounts.AccountType.defined_benefit"),
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_FIXED_ANNUITY,
      name: t("ClientDetails.Profile.Accounts.AccountType.fixed_annuity"),
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_PROFIT_SHARING_PLAN,
      name: t("ClientDetails.Profile.Accounts.AccountType.profit_sharing_plan"),
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_ROLLOVER_IRA,
      name: t("ClientDetails.Profile.Accounts.AccountType.rollover_ira"),
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_SEP_IRA,
      name: t("ClientDetails.Profile.Accounts.AccountType.sep_ira"),
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_SIMPLE_IRA,
      name: t("ClientDetails.Profile.Accounts.AccountType.simple_ira"),
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_TRADITIONAL_IRA,
      name: t("ClientDetails.Profile.Accounts.AccountType.traditional_ira"),
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_VARIABLE_ANNUITY,
      name: t("ClientDetails.Profile.Accounts.AccountType.variable_annuity"),
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_ESOP,
      name: t("ClientDetails.Profile.Accounts.AccountType.esop"),
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_OTHER,
      name: t("ClientDetails.Profile.Accounts.AccountType.other"),
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_BROKERAGE,
      name: t("ClientDetails.Profile.Accounts.AccountType.brokerage"),
      category: TAX_CATEGORY_TAXABLE,
    },
    {
      key: ACCOUNTTYPE_INDIVIDUAL,
      name: t("ClientDetails.Profile.Accounts.AccountType.individual"),
      category: TAX_CATEGORY_TAXABLE,
    },
    {
      key: ACCOUNTTYPE_TRUST,
      name: t("ClientDetails.Profile.Accounts.AccountType.trust"),
      category: TAX_CATEGORY_TAXABLE,
    },
    {
      key: ACCOUNTTYPE_JOINT_ACCOUNT,
      name: t("ClientDetails.Profile.Accounts.AccountType.joint_account"),
      category: TAX_CATEGORY_TAXABLE,
    },
    {
      key: ACCOUNTTYPE_TENANTS_BY_ENTIRETY,
      name: t("ClientDetails.Profile.Accounts.AccountType.tenants_by_entirety"),
      category: TAX_CATEGORY_TAXABLE,
    },
    {
      key: ACCOUNTYPE_TENANTS_IN_COMMON,
      name: t("ClientDetails.Profile.Accounts.AccountType.tenants_in_common"),
      category: TAX_CATEGORY_TAXABLE,
    },
    {
      key: ACCOUNTTYPE_CUSTODIAL_ACCOUNT,
      name: t("ClientDetails.Profile.Accounts.AccountType.custodial_account"),
      category: TAX_CATEGORY_TAXABLE,
    },
    {
      key: ACCOUNTTYPE_CORPORATE_ACCOUNT,
      name: t("ClientDetails.Profile.Accounts.AccountType.corporate_account"),
      category: TAX_CATEGORY_TAXABLE,
    },
    {
      key: ACCOUNTTYPE_PARTNERSHIP,
      name: t("ClientDetails.Profile.Accounts.AccountType.partnership"),
      category: TAX_CATEGORY_TAXABLE,
    },
    {
      key: ACCOUNTTYPE_SOLE_PROPRIETORSHIP,
      name: t("ClientDetails.Profile.Accounts.AccountType.sole_proprietorship_account"),
      category: TAX_CATEGORY_TAXABLE,
    },
    {
      key: ACCOUNTTYPE_ROTH_IRA,
      name: t("ClientDetails.Profile.Accounts.AccountType.roth_ira"),
      category: TAX_CATEGORY_EXEMPT,
    },
    {
      key: ACCOUNTTYPE_ROTH_401K,
      name: t("ClientDetails.Profile.Accounts.AccountType.roth_401k"),
      category: TAX_CATEGORY_EXEMPT,
    },
    {
      key: ACCOUNTTYPE_529_PLAN,
      name: t("ClientDetails.Profile.Accounts.AccountType.529_plan"),
      category: TAX_CATEGORY_EXEMPT,
    },
    {
      key: ACCOUNTTYPE_COVERDELL_ESA,
      name: t("ClientDetails.Profile.Accounts.AccountType.coverdell_esa"),
      category: TAX_CATEGORY_EXEMPT,
    },
    {
      key: ACCOUNTTYPE_CASH_ACCOUNT,
      name: t("ClientDetails.Profile.Accounts.AccountType.cash_account"),
      category: TAX_CATEGORY_EXEMPT,
    },
  ];
  accountTypeList.sort((a, b) => {
    if (a.name > b.name) return 1;
    if (b.name > a.name) return -1;
    return 0;
  });
  return accountTypeList;
};